module.exports = __webpack_public_path__ + "assets/right-arrow-icon.449644f3.svg";